import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: "/",
      name: "Home",
      component: () => import('@/views/public/Home.vue'),
      exact: true,
      meta: { requiresAuth: false }
    },
    {
      path: '/solutions',
      name: 'IndustrySolutions',
      component: () => import('@/views/public/IndustrySolutions.vue'),
      meta: { requiresAuth: false }
    }, 
    {
        path: '/product-intro',
        name: 'ProductIntro',
        component: () => import('@/views/public/ProductIntro.vue'),
        meta: { requiresAuth: false }
      },
    {
        path: '/Pricing',
        name: 'Pricing',
        component: () => import('@/views/public/Pricing.vue'),
        meta: { requiresAuth: false }
      },      
    {
      path: '/register',
      name: 'Register',
      component: () => import('@/views/public/Register.vue'),
      meta: { requiresAuth: false }
    },
    {
      path: '/login',
      name: 'Login',
      component: () => import('@/views/public/Login.vue'),
      meta: { requiresAuth: false }
    },
    {
      path: '/password-login',
      name: 'PasswordLogin',
      component: () => import('@/views/public/password-login.vue'),
      meta: { requiresAuth: false }
    },
    
    // ==================== 管理后台主布局 ====================
    {
      path: '/admin',
      name: 'AdminLayout',
      component: () => import('@/views/admin/main.vue'), // 主布局组件
      meta: { requiresAuth: true },
      children: [
        // 默认重定向到仪表盘
        {
          path: '',
          redirect: '/admin/dashboard',
          name: 'AdminRoot'
        },
        // 数据概览
        {
          path: 'dashboard',
          name: 'AdminDashboard',
          component: () => import('@/components/admin/dashboard.vue'),
          meta: { title: '数据概览', requiresAuth: true }
        },
        // 团队管理
        {
          path: 'employees',
          name: 'AdminEmployees',
          component: () => import('@/components/admin/employees.vue'),
          meta: { title: '团队管理', requiresAuth: true }
        },
        // 知识库工作空间列表
        {
          path: 'knowledge',
          name: 'AdminKnowledge',
          component: () => import('@/components/admin/KbWorkspaceManage.vue'),
          meta: { title: '知识库', requiresAuth: true }
        },
        // 知识库具体工作空间文档列表（带参数）
        {
          path: 'knowledge/:workspaceSlug',
          name: 'KnowledgeWorkspace',
          component: () => import('@/components/admin/KbDocuments.vue'),
          props: route => ({
            workspaceSlug: route.params.workspaceSlug,
            workspaceName: route.query.workspaceName || '',
            tenantId: store.state.auth.tenantInfo?.tenantId,
            userType: 'admin'
          }),
          meta: { title: '知识库文档', requiresAuth: true }
        },
        // 图片库管理
        {
          path: 'imagelibrary',
          name: 'ImageLibrary',
          component: () => import('@/components/aics/ImageLibrary.vue'),
   /**       props: route => ({
            username: store.state.auth.userInfo?.username
          }),*/
          meta: { title: '图片库管理', requiresAuth: true }
        },
        // 操作日志
        {
          path: 'operationlog',
          name: 'AdminOperationLog',
          component: () => import('@/components/aics/operationLog.vue'),
   /**       props: route => ({
            username: store.state.auth.userInfo?.username
          }),*/
          meta: { title: '操作日志', requiresAuth: true }
        },        
        // 统计报表
        {
          path: 'statistics',
          name: 'StatisticsCenter',
          component: () => import('@/components/admin/statisticsCenter.vue'),
          meta: { title: '统计', requiresAuth: true }
        },
        // 套餐与流量包
        {
          path: 'plan-and-package',
          name: 'PlanAndPackage',
          component: () => import('@/components/admin/plan_and_package.vue'),
          meta: { title: '套餐与流量包', requiresAuth: true }
        },
        // 购物车
        {
          path: 'cart',
          name: 'Cart',
          component: () => import('@/components/admin/cart.vue'),
         /** props: route => ({
            username: store.state.auth.userInfo?.username
          }),**/
          meta: { title: '购物车', requiresAuth: true }
        },
        {
          path: 'order/checkout',
          name: 'Checkout',
          component: () => import('@/components/admin/checkout.vue'),
          meta: { requiresAuth: true }
        },       
        {
          path: 'order/success',
          name: 'OrderSuccess',
          component: () => import('@/components/admin/order-success.vue'),
          meta: { 
            title: '支付成功',
            requiresAuth: true 
          }
        },
        {
          path: 'orders',
          name: 'orders',
          component: () => import('@/components/admin/order-list.vue'),
          meta: { title: '订单管理', requiresAuth: true }
        },
        {
          path: 'messages',
          name: 'messages',
          component: () => import('@/components/admin/messages.vue'),
          meta: { title: '站内信', requiresAuth: true }
        },
                {
          path: 'batch-messages',
          name: 'batch-messages',
          component: () => import('@/components/admin/batch-messages.vue'),
          meta: { title: '站内信', requiresAuth: true }
        },
        {
          path: 'feedback',
          name: 'FeedbackList',
          component: () => import('@/views/admin/feedback.vue'),
          meta: { title: '意见反馈' }
        },
        {
          path: 'account_setting',
          name: 'accountSetting',
          component: () => import('@/views/admin/account_setting.vue'),
          meta: { title: '意见反馈' }
        }                      
      ]
    },
    
    // ==================== 保留原来的单页面路由（兼容性） ====================
    {
      path: '/admin/main',
      name: 'adminMainOld',
      redirect: '/admin/dashboard', // 重定向到新路由
      meta: { requiresAuth: true }
    },
    
    // ==================== 其他路由 ====================
    {
      path: '/employee/workspace',
      name: 'EmployeeWorkspace',
      component: () => import('@/views/employee/workspace.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/raw_user/home',
      name: 'rawUserHome',
      component: () => import('@/views/raw_user_home.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/chat',
      name: 'Chat',
      component: () => import('@/views/public/chat.vue'),
      meta: { requiresAuth: false }
    },
  /**  {
      path: '/order/checkout',
      name: 'Checkout',
      component: () => import('@/views/admin/order/checkout.vue'),
      meta: { requiresAuth: true }
    },**/
    
    // ==================== 404 页面 ====================
    /**{
      path: '*',
      name: 'NotFound',
      component: () => import('@/views/public/NotFound.vue'),
      meta: { requiresAuth: false }
    }**/
  ]
})

// 全局路由守卫
router.beforeEach(async (to, from, next) => {
  const token = localStorage.getItem('auth_token')
  const userInfo = JSON.parse(localStorage.getItem('auth_user') || 'null')
  
  // 🔴 定义公开页面（不需要登录）
  const publicPages = [
    '/', 
    '/login', 
    '/register', 
    '/password-login', 
    '/solutions', 
    '/product-intro', 
    '/Pricing', 
    '/chat'
  ]
  
  // 如果有 token 且 userInfo 存在，已登录
  if (token && userInfo) {
    if (!store.state.auth.userInfo) {
      store.commit('auth/SET_USER_INFO', {
        username: userInfo.username,
        registerTime: userInfo.registerTime,
        roles: userInfo.roles,
        tenantUserInfo: null,
        employeeUserInfo: null
      })
    }
    next()
    return
  }
  
  // 公开页面直接放行
  if (publicPages.some(path => to.path === path || to.path.startsWith(path + '/'))) {
    next()
    return
  }
  
  // 其他页面跳转登录
  next('/login')
})

export default router